import {
  DialogTitle,
  IconButton,
  DialogContent,
  DialogActions,
  Button,
  Box,
  Grid,
  Typography,
  Stack,
  Tooltip,
  Chip,
  Dialog
} from '@mui/material'
import { Circle, CircleHalfFull, Close, MenuDown } from 'mdi-material-ui'
import * as React from 'react'
import { useTranslation } from 'react-i18next'
import { styled } from '@mui/material/styles'
import { Sample, Variation } from '@/@core/services/app.service'
import { ColumnDef } from '@tanstack/react-table'
import { formatVariantInheritance } from '@/@core/utils/utils'
import Slide from '@mui/material/Slide'
import TanStackTable from '@/@core/components/tanstack-tables'

import CloseIcon from '@mui/icons-material/Close'
import Checkbox from '@mui/material/Checkbox'
import FormControlLabel from '@mui/material/FormControlLabel'
import _ from 'lodash'
import { TransitionProps } from '@mui/material/transitions'
import { GridColDef } from '@mui/x-data-grid'
import Tables from '@/@core/components/tables'

const TypographyA = styled(Typography)(() => ({
  fontSize: '0.75rem',
  color: 'inherit'
}))

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement<any, any>
  },
  ref: React.Ref<unknown>
) {
  return <Slide direction="down" ref={ref} {...props} />
})

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiPaper-root': {
    maxWidth: 'none'
  },
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2)
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1)
  }
}))

const SamplesTable = (props: any) => {
  const { t } = useTranslation()

  const columns: GridColDef[] = [
    { field: 'id', headerName: 'ID', width: 60, sortable: false },
    {
      field: 'name',
      headerName: t('name'),
      flex: 1,
      editable: false,
      sortable: false,
      renderCell: (params) => {
        return (
          <Box
            onClick={() => {
              window.open(`/samples/SampleTabs/${params.row.id}/`)
            }}
            sx={{
              ':hover': {
                color: '#32B0C9'
              },
              cursor: 'pointer'
            }}
          >
            {params.row.name}
          </Box>
        )
      }
    },
    {
      field: 'totalVariants',
      headerName: t('totalVariants'),
      width: 100,
      editable: false,
      sortable: false
    },
    {
      field: 'gender',
      headerName: t('gender'),
      width: 100,
      editable: false,
      sortable: false,
      renderCell: (row) => {
        return <Typography>{t(row.row.gender)}</Typography>
      }
    },
    {
      field: 'type',
      headerName: t('type'),
      width: 100,
      editable: false,
      sortable: false,
      renderCell: (row) => {
        return <Typography>{t(row.row.type)}</Typography>
      }
    }
  ]

  const data = React.useMemo(() => {
    if (props.current && props.samples) {
      const case_samples = props.current.case_samples ?? []
      const control_samples = props.current.control_samples ?? []
      const samples = props.samples as Sample[]

      const total = [...case_samples, ...control_samples]
        .map((items) => {
          const temp = samples.find((i) => i.id == items)
          if (temp) return temp
        })
        .filter((item) => item)

      return total
    }

    return []
  }, [props])

  return (
    <Box minWidth={1200}>
      <Grid container width={'100%'} height={'100%'} spacing={4}>
        <Grid item xs={12}>
          <Stack spacing={6} width="100%">
            <Tables
              rows={data as any[]}
              columns={columns}
              initialState={{
                pagination: {
                  paginationModel: {
                    pageSize: 99
                  }
                }
              }}
              pageSizeOptions={[100]}
              checkboxSelection={false}
              disableRowSelectionOnClick
              disableColumnMenu
              disableVirtualization
              rowCount={data.length}
              slots={null}
              sx={{
                height: 330,
                '& .MuiDataGrid-footerContainer': {
                  justifyContent: 'center',
                  display: 'none'
                },
                '& .MuiDataGrid-columnHeaders': {
                  bgcolor: '#EDEFF0'
                }
              }}
            />
          </Stack>
        </Grid>
      </Grid>
    </Box>
  )
}
export default SamplesTable
